import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import {
  monthOptions,
  yearOptions,
} from "../../../dashboardLevelMekanikSA/dasboardLaporanHarianPartByMekanikdanSA/config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { mapToSimpleNestedTable } from "./config";
import SimpleNestedTable from "../../../../../../modules/SimpleNestedTable";
import { buildExcelRequestBodyPartHarian } from "../configExcel";
import { saveAs } from "file-saver";

export default class LaporanPartHarian extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      dataTable: [],
      tableConfig: [],
      rawData: null
    };
  }

  componentDidMount() {
    const currentMonth = Number(moment().format("MM"));
    const currentYear = Number(moment().format("YYYY"));
    this.setState({
      month: monthOptions.find((item) => item.value === currentMonth),
      year: yearOptions.find((item) => item.value === currentYear),
    });
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanHarianPartByMekanik,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kabeng Keatas - Laporan Part Harian By Cabang",
        args: {
          listCabang: this.props.search,
          year: this.state.year.value,
          month: this.state.month.value,
          employeeId: null,
        },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const { data, config } = mapToSimpleNestedTable({
          apiData: res.data.data,
          month: this.state.month.value,
          year: this.state.year.value,
        });

        this.setState({
          dataTable: data,
          tableConfig: config,
          rawData: res.data.data
        });
      }

      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.error("Error Fetching", error);
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    console.log("cek");
    
    this.props.triggerLoading();
    const { month, year, rawData } = this.state;

    const reqBody = buildExcelRequestBodyPartHarian({
      month,
      year: year.value,
      rawData,
    });

    try {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateAdvancedExcelFromPayload,
        menuName:
          "Dashboard Level Mekanik dan SA - Laporan Part Harian By Mekanik",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
    }

    this.props.triggerLoading();
  };

  render() {
    const { month, year, dataTable } = this.state;
    return (
      <React.Fragment>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>

        <SimpleNestedTable
          data={this.state.dataTable}
          config={this.state.tableConfig}
        />

        <FlexView hAlignContent="right">
          <SimpleButton text="CETAK" onClick={this.handlePrint} />
        </FlexView>
      </React.Fragment>
    );
  }
}
